var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHashtag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5053 17L12.8632 3H14.5474L12.1895 17H10.5053ZM4 13.2539L4.27368 11.6133H15.1649L14.8912 13.2539H4ZM5.45263 17L7.81053 3H9.49474L7.13684 17H5.45263ZM4.83509 8.38672L5.10877 6.74609H16L15.7263 8.38672H4.83509Z",
    fill: "#DCDBE7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHashtag);
export default __webpack_public_path__ + "static/media/Hashtag.793ceb58455d47a6580df2af4f529ce2.svg";
export { ForwardRef as ReactComponent };